import { Box, ButtonBase, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AppBarContainer from "../../components/shared/AppBarContainer";
import { ReactComponent as NotifIcon } from "../../assets/icons/notif-icon.svg";
import PageContentContainer from "../../components/shared/PageContentContainer";
import {
  FinancialAssetSubType,
  FinancialAssetSubTypeFarsi,
} from "../../types/FinancialAssets";
import StartAutoInvestmentBanner from "../../components/home/StartAutoInvestmentBanner";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import FinancialAssetCard from "../../components/investment/FinancialAssetCard";
import { useNavigate } from "react-router-dom";
import { ReactComponent as FAEmptyState } from "../../assets/empty-states/financial-assets-es.svg";
import CustomRectangularSkeleton from "../../components/shared/CustomRectangularSkeleton";

function InvestmentPage() {
  const navigate = useNavigate();
  const [activeSubType, setActiveSubType] = useState(
    FinancialAssetSubType.FUND_FIXED_INCOME
  );

  const [financialAssets, setFinancialAssets] = useState([]);

  const {
    loading,
    result,
    apiCall: getFinancialAssets,
  } = useRequest(BalootUserAPIs.getFinancialAssets, true);

  useEffect(() => {
    getFinancialAssets({
      onSuccess: (response) => {
        setFinancialAssets(response.content);
      },
    });
  }, []);

  return (
    <>
      <AppBarContainer
        rightElement={
          <Typography variant="h5" color={"common.white"}>
            سرمایه‌گذاری
          </Typography>
        }
        leftElement={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              onClick={() => {
                navigate("/app/messages");
              }}
              sx={{ display: "flex", alignItems: "center", ml: "8px" }}
            >
              <NotifIcon />
            </Box>
          </Box>
        }
      />
      <Box
        sx={{
          width: "100%",
          position: "relative",
          zIndex: 1,
          mb: "-40px",
          px: "24px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            p: "4px",
            boxShadow: (theme) => theme.shadows[2],
            bgcolor: "common.white",
            borderRadius: "8px",
          }}
        >
          {[
            {
              title: "درآمد ثابت",
              value: FinancialAssetSubType.FUND_FIXED_INCOME,
            },
            { title: "سهامی", value: FinancialAssetSubType.FUND_EQUITY },
            { title: "مختلط", value: FinancialAssetSubType.FUND_BALANCED },
          ].map((item, index) => {
            const isActive = activeSubType === item.value;
            return (
              <ButtonBase
                key={item.title}
                onClick={() => {
                  setActiveSubType(item.value);
                }}
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "6px",
                  bgcolor: isActive ? "grey.2" : "common.white",
                  height: 32,
                }}
              >
                <Typography
                  variant="h5"
                  color={isActive ? "common.white" : "grey.4"}
                >
                  {item.title}
                </Typography>
              </ButtonBase>
            );
          })}
        </Box>
      </Box>
      <PageContentContainer
        sx={{
          mt: "20px",
          overflow: "auto",
          pt: 4,
          display: "block",
        }}
      >
        <StartAutoInvestmentBanner />
        {loading ? (
          <>
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={160} />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={160} />
          </>
        ) : financialAssets.filter(
            (item) => item.asset.subType === activeSubType
          ).length === 0 ? (
          <Box
            sx={{
              mt: 4,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <FAEmptyState width={132} height={134} />
            <Typography mt={2} variant="subtitle1" color="grey.4">
              {`صندوق‌های ${FinancialAssetSubTypeFarsi[activeSubType]} به زودی اضافه می‌شوند.`}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
            {financialAssets
              .filter((item) => item.asset.subType === activeSubType)
              .map((financialAsset) => {
                return (
                  <FinancialAssetCard
                    key={financialAsset.asset.id}
                    financialAsset={financialAsset.asset}
                    onClick={() => {
                      navigate(
                        `/app/financial-asset/${financialAsset.asset.id}`,
                        { state: { assetName: financialAsset.asset.name } }
                      );
                    }}
                  />
                );
              })}
          </Box>
        )}
      </PageContentContainer>
    </>
  );
}

export default InvestmentPage;
